var React = require('react');

function DrawFields (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-.5)","fill":"currentColor"},[React.createElement("path",{"opacity":".05","d":"M76.5 5H21.1L4.5 78l144-16.7-35.3-29.5","key":0}),React.createElement("path",{"d":"M2.6 79.7L19.9 3.5h56.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H22.3L6.4 76.3l138.4-16L112.3 33c-.6-.5-.7-1.5-.2-2.1.5-.6 1.5-.7 2.1-.2l38 31.7L2.6 79.7z","key":1}),React.createElement("circle",{"cx":"21","cy":"4.5","r":"4.5","key":2}),React.createElement("circle",{"cx":"5","cy":"79.5","r":"4.5","key":3}),React.createElement("circle",{"cx":"149","cy":"61.5","r":"4.5","key":4}),React.createElement("path",{"d":"M112.5 37h-4v-6.5H102v-4h6.5V20h4v6.5h6.5v4h-6.5z","key":5})]));
}

DrawFields.defaultProps = {"viewBox":"0 0 153 84"};

module.exports = DrawFields;

DrawFields.default = DrawFields;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/draw-fields.svg
// module id = 1479
// module chunks = 0